import React from 'react';
import { reduxForm, Field } from 'redux-form';

import CheckboxField from 'components/CheckboxField';
import InputField from 'components/InputField';
import SelectField from 'components/SelectField';
import FormError from 'components/FormError';

const ExpireSubForm = ({
  handleSubmit,
  error,
  types,
  carrier,
  showBypass = false,
  showProration = true,
  showPin,
}) => (
  <form onSubmit={handleSubmit}>
    {showPin && <Field component={InputField} name="pin" />}
    <Field
      component={SelectField}
      name="expiry_type"
      label="Types"
      options={types}
    />
    {showProration && (
      <Field
        component={CheckboxField}
        name="skip_proration"
        label="Skip Proration"
      />
    )}
    {showBypass && carrier && (
      <Field
        component={CheckboxField}
        name={`bypass_${carrier}`}
        label="Bypass AT&T"
      />
    )}
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-primary">Expire Subscription</button>
  </form>
);

const validate = (values, { showPin, isQuick }) => {
  let errors = {};

  if (showPin && !isQuick && !values.pin) {
    errors.pin = 'Required';
  }

  if (!values.type) {
    errors.type = 'Required';
  }

  return errors;
};

export default reduxForm({
  form: 'expireSub',
  validate,
  enableReinitialize: true,
})(ExpireSubForm);
